import DocAdd from './DocAdd';

export default DocAdd;
